var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.5,
    width: 29,
    height: 29,
    rx: 14.5,
    transform: "rotate(-180 29.5 29.5)",
    stroke: "#919191",
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7998 14.9999L20.5069 14.2928L21.214 14.9999L20.5069 15.707L19.7998 14.9999ZM10.7998 15.9999C10.2475 15.9999 9.79982 15.5522 9.79982 14.9999C9.79982 14.4476 10.2475 13.9999 10.7998 13.9999L10.7998 15.9999ZM16.9069 10.6928L20.5069 14.2928L19.0927 15.707L15.4927 12.107L16.9069 10.6928ZM20.5069 15.707L16.9069 19.307L15.4927 17.8928L19.0927 14.2928L20.5069 15.707ZM19.7998 15.9999L10.7998 15.9999L10.7998 13.9999L19.7998 13.9999L19.7998 15.9999Z",
    fill: "#919191"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.34a03ceff726a6e0946365afa3f92a48.svg";
export { ForwardRef as ReactComponent };